import Heatmap from "../../../../src/posts/2019-04-21-lexicographical-disordering/Heatmap";
import data from "../../../../src/posts/2019-04-21-lexicographical-disordering/data.json";
import * as React from 'react';
export default {
  Heatmap,
  data,
  React
};